jQuery(document).ready(function( $ ) {

  $bottom = parseInt($('.toTop').css('bottom').replace('px',''));

  $toTopisShown = false;
  $('.toTop').hide();

  $(window).on('scroll', function(){

    if($toTopisShown && $(window).scrollTop() <= 50) {
      $toTopisShown = false;
      $('.toTop').hide(500);
    }

    if(!$toTopisShown && $(window).scrollTop() > 50) {
      $toTopisShown = true;
      $('.toTop').show(500);
    }

    $stop = $('html').height() - $('footer').height();
    $bottomOfScreen = $(window).scrollTop() + window.innerHeight

    if($stop < $bottomOfScreen) {
      $('.toTop').css('bottom', $bottomOfScreen-$stop+$('.toTop').height()+'px');
    } else {
      $('.toTop').css('bottom', $bottom+'px');
    }

  });

  $('.toTop').on('click', function(){
    $('html, body').animate({ scrollTop: 0 }, 500);
  });

});
